import i18n, { i18n_t } from '@/locales/i18n';
export const businessOptions = [
  {
    label: i18n_t('批发零售业'),
    value: '0',
  },
  {
    label: i18n_t('服务业'),
    value: '1',
  },
  {
    label: i18n_t('制造业'),
    value: '2',
  },
  {
    label: i18n_t('教育'),
    value: '3',
  },
  {
    label: i18n_t('设计'),
    value: '4',
  },
  {
    label: i18n_t('其他'),
    value: '5',
  },
];
export const scaleOptions = [
  {
    label: i18n_t('20人以下'),
    value: '0',
  },
  {
    label: i18n_t('21~100人'),
    value: '1',
  },
  {
    label: i18n_t('100人以上'),
    value: '2',
  },
];

// 下面的是新的产品要求的行业定义
export const businessOptions2 = [
  {
    label: i18n_t('制造业'),
    value: i18n_t('制造业'),
  },
  {
    label: i18n_t('金融行业'),
    value: i18n_t('金融行业'),
  },
  {
    label: i18n_t('保险行业'),
    value: i18n_t('保险行业'),
  },
  {
    label: i18n_t('教育行业'),
    value: i18n_t('教育行业'),
  },
  {
    label: i18n_t('媒体行业'),
    value: i18n_t('媒体行业'),
  },
  {
    label: i18n_t('地产行业'),
    value: i18n_t('地产行业'),
  },
  {
    label: i18n_t('物流行业'),
    value: i18n_t('物流行业'),
  },
  {
    label: i18n_t('设计行业'),
    value: i18n_t('设计行业'),
  },
  {
    label: i18n_t('互联网行业'),
    value: i18n_t('互联网行业'),
  },
  {
    label: i18n_t('其他'),
    value: i18n_t('其他'),
  },
];
export const scaleOptions2 = [
  {
    label: i18n_t('1-3人'),
    value: i18n_t('1-3人'),
  },
  {
    label: i18n_t('4-10人'),
    value: i18n_t('4-10人'),
  },
  {
    label: i18n_t('11-30人'),
    value: i18n_t('11-30人'),
  },
  {
    label: i18n_t('31-50人'),
    value: i18n_t('31-50人'),
  },
  {
    label: i18n_t('50-100人'),
    value: i18n_t('50-100人'),
  },
  {
    label: i18n_t('101-500人'),
    value: i18n_t('101-500人'),
  },
  {
    label: i18n_t('500人以上'),
    value: i18n_t('500人以上'),
  },
];
